import React, { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface LoginLayoutProps {
  children: ReactNode;
}

const LoginLayout: React.FC<LoginLayoutProps> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen grid grid-cols-1 md:grid-cols-2 bg-background text-foreground transition-colors">
      <div className="bg-primary text-primary-foreground flex flex-col justify-center items-center px-8 py-12 space-y-6">
        <div className="w-full max-w-sm text-left space-y-4">
          <h1 className="text-4xl font-bold leading-tight">
            {t('loginLayout.Welcome back to Tendril Connect')}
          </h1>
          <p className="dark:text-muted-foreground">
            {t(
              'loginLayout.Sign in to your account and continue where you left off.',
            )}
          </p>
          <p className="text-xs dark:text-muted-foreground">
            <a href="#" className="underline">
              {t('loginLayout.Terms of Use')}
            </a>{' '}
            {t('loginLayout.and')}{' '}
            <a href="#" className="underline">
              {t('loginLayout.Privacy Policy')}
            </a>
          </p>
        </div>
      </div>

      <div className="flex justify-center items-center bg-background p-8 text-foreground">
        {children}
      </div>
    </div>
  );
};

export default LoginLayout;
